// src/navigation/useSafeBackNavigation.ts

import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { canGoBack } from "./navigationTracker";

/**
 * @description - A hook that provides a safe back navigation function. It checks if it's possible to go back in the navigation stack, and if not, it redirects to a specified home path.
 * @param {string} homePath - The path to navigate to if back navigation is not possible. Defaults to "/".
 * @returns {function} - A function that can be called to perform safe back navigation.
 */
export const useSafeBackNavigation = (homePath: string = "/") => {
  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    if (canGoBack()) {
      navigate(-1);
    } else {
      // Prevent loop by replacing instead of pushing
      navigate(homePath, { replace: true });
    }
  }, [navigate, homePath]);

  return handleBack;
};
